module.exports = __webpack_public_path__ + "static/sunkenforest2@fiwatertaxi.3154fc25.jpg";